const Link = ({node, ...props}: any) => {
    const httpString = (s: string) => {
        const reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
        return s.match(reg);
    }
    const isValidDomain = (domain: string) => {
        const domainPattern = /^(?!:\/\/)([a-zA-Z0-9-_]+.)*[a-zA-Z0-9][a-zA-Z0-9-_]+.[a-zA-Z]{2,11}?$/;
        return domainPattern.test(domain);
    }
    if (props.href && isValidDomain(props.href)) {
        props.href = 'http://' + props.href;
    }
    const reg = /[\u4e00-\u9fa5]+/g;
    
    // 安全解码URI
    const safeDecodeURI = (uri: string) => {
        try {
            return decodeURIComponent(uri);
        } catch (e) {
            console.warn('Invalid URI encoding:', uri);
            return uri; // 返回原始值
        }
    };
    
    if (node.properties?.href && node.properties.href?.toString().startsWith('abbr')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const clickFunc = (value: string) => {
            console.log(value);
        };
        let hidden_text = '';
        try {
            hidden_text = decodeURIComponent(node.properties.href.toString().split('abbr:')[1]);
        } catch (e) {
            hidden_text = node.properties.href.toString().split('abbr:')[1] || '';
            console.warn('无法解码abbr链接:', node.properties.href);
        }
        
        return <abbr className="cursor-pointer underline !decoration-primary-700 decoration-dashed"
                     onClick={() => clickFunc(hidden_text)}
                     title={node.children[0]?.value}>{node.children[0]?.value}</abbr>
    } else if (node.properties?.href) {
        // 使用安全解码函数
        const decodedHref = safeDecodeURI(node.properties.href.toString());
        const hasChineseChars = decodedHref.match(reg);
        
        if (hasChineseChars) {
            let url = httpString(decodedHref);
            if (url && url.length) {
                props.href = url[0];
            }
        }
        
        return <a {...props} target="_blank"
                  className="cursor-pointer underline !decoration-primary-700 decoration-dashed">{node.children[0] ? node.children[0]?.value : 'Download'}</a>
    } else {
        return <a {...props} target="_blank"
                  className="cursor-pointer underline !decoration-primary-700 decoration-dashed">{node.children[0] ? node.children[0]?.value : 'Download'}</a>
    }
}
export default Link;
